var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "our-services-offers-switch" }, [
      _c("label", { staticClass: "selection-item" }, [
        _c("span", [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("our-services.professional")) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "switch" }, [
          _c("input", {
            attrs: { type: "checkbox" },
            domProps: { checked: _vm.priceIndividual },
            on: {
              change: function($event) {
                _vm.priceIndividual = !_vm.priceIndividual
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "slider" })
        ]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("our-services.individual")) +
              "\n            "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "our-services-offers-container" },
      [
        _vm._l(_vm.offers, function(offer, offerIndex) {
          return _c(
            "div",
            { key: offerIndex, staticClass: "offer-card-wrapper" },
            [
              _c("div", { staticClass: "offer-card" }, [
                _c("div", { staticClass: "offer-header-container" }, [
                  _c("div", { staticClass: "premium-banner-container" }, [
                    offer.is_premium
                      ? _c("div", { staticClass: "premium-banner" }, [
                          _c("div", { staticClass: "banner-title" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("our-services.premium-club")) +
                                "\n                            "
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "offer-header",
                    domProps: { innerHTML: _vm._s(offer.name) }
                  }),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c(
                        "a",
                        {
                          class: [
                            "collapse-button",
                            _vm.isVisible(offerIndex)
                              ? "rotate-open"
                              : "rotate-close"
                          ],
                          on: {
                            click: function($event) {
                              _vm.collapsedOffers[offerIndex] = !_vm
                                .collapsedOffers[offerIndex]
                            }
                          }
                        },
                        [
                          _c(
                            "i",
                            { staticClass: "material-icons arrow-down-icon" },
                            [_vm._v("keyboard_arrow_down")]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("h3", {
                  staticClass: "offer-pricing",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.priceIndividual
                        ? offer.pricing_individual
                        : offer.pricing
                    )
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      _vm.isVisible(offerIndex) || !_vm.isMobile
                        ? "collapse-open"
                        : "collapse-close",
                      "collapsible-details",
                      offerIndex == "free" ? "free" : ""
                    ]
                  },
                  [
                    _c(
                      "table",
                      { staticClass: "offer-details-container" },
                      _vm._l(offer.details, function(detail, detailIndex) {
                        return _c("tr", { key: detailIndex }, [
                          _vm._m(0, true),
                          _vm._v(" "),
                          _c("td", { domProps: { innerHTML: _vm._s(detail) } })
                        ])
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "md-button md-raised md-primary md-theme-default offer-button",
                    attrs: { href: "/registration/fill-profile" }
                  },
                  [
                    _c("span", { staticClass: "md-ripple md-disabled" }, [
                      _vm._v(_vm._s(_vm.$t("our-services.register")))
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              !_vm.isMobile
                ? _c(
                    "div",
                    _vm._l(offer.footnotes, function(footnote, footnoteIndex) {
                      return _c("div", { key: footnoteIndex }, [
                        _c("p", {
                          staticClass: "card-footnote",
                          domProps: { innerHTML: _vm._s(footnote) }
                        })
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ]
          )
        }),
        _vm._v(" "),
        _vm.isMobile
          ? _c(
              "div",
              _vm._l(_vm.allFootnotes, function(footnote, footnoteIndex) {
                return _c("div", { key: footnoteIndex }, [
                  _c("p", {
                    staticClass: "card-footnote",
                    domProps: { innerHTML: _vm._s(footnote) }
                  })
                ])
              }),
              0
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("img", {
        staticClass: "plane-icon",
        attrs: { src: "/imgs/icons/green-plane.webp", alt: "" }
      })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0707b9a5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0707b9a5","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/OffersCards.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0707b9a5","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/OffersCards.vue
// module chunks = 1 2 3